const styles = {
  LOGIN_CONTAINER: {
    backgroundImage: 'url("https://d3mm0hr4pcjpix.cloudfront.net/bg.svg")',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    minHeight: '100vh',
    width: '100%'
  }
}

export default styles